import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';

export const DeleteMasterSlice = createSlice({
  name: 'DeletePricing',
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deletePricing: (state, _) => {
      state.isLoading = true;
    },
    successDeletePricing: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeletePricing: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeletePricing: (state) => {
      state.data = {};
    },
  },
});

export const {
  deletePricing,
  successDeletePricing,
  failureDeletePricing,
  clearDeletePricing,
} = DeleteMasterSlice.actions;

export default DeleteMasterSlice.reducer;
